import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Box from '@mui/material/Box'
import DialogLcs from '../Components/DialogLcs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChartLine,
  faClipboardCheck,
  faCrosshairs,
  faSparkles,
  faStar,
  faTriangleExclamation
} from '@fortawesome/pro-solid-svg-icons'

import InfoCard from '../Components/InfoCard'
import groupBy from 'lodash/groupBy'
import SelectField from '../../../../../FormControl/input/SelectField'
import { FormControl, Select, MenuItem, ListSubheader, Typography, Skeleton } from '@mui/material'
import CardChart from '../Components/CardChart'
import { setCurrentLearningArea } from '../../../../../../store/actions/assessment.actions'
import ListButton from '../Components/ListButton'
import SkillsSnapshot from './ SkillsSnapshot'
import YourGrowthJourney from './YourGrowthJourney'

const LearningAreaOverview = ({ isLoadingDashboard, data }) => {
  const filteredLcs = data?.lcs || []
  const assessedCount = filteredLcs.filter((lc) => !lc.main)
  const selfCheckCount = filteredLcs.filter((lc) => !lc.main && lc.sizeLogMarkingStudent > 0)
  const growingCount = filteredLcs.filter((lc) => !lc.main && lc.sizeLogMarkingTeacher > 0)

  const learningAreas = useSelector((state) => state?.assessment?.learningAreas || [])
  const isLoadingCurriculum = useSelector((state) => state?.assessment?.loading || false)
  const currentLA = useSelector((state) => state?.assessment?.currentLearningArea || null)
  const groupedOptions = groupBy(learningAreas, 'curriculumCode')
  const dispatch = useDispatch()
  const [modal, setModal] = useState({ show: false, type: null, data: null })

  const onChange = (e) => {
    dispatch(setCurrentLearningArea(e.target.value))
  }

  return (
    <Box sx={{ border: `1px solid #E2E5EA`, borderRadius: 1, bgcolor: '#E2E5EA' }}>
      <div className='pl-4 sticky top-0px z-1' style={{ marginTop: -20 }}>
        <div
          className='flex items-center gap-2 px-2 py-2 text-muted-foreground max-w-200px min-w-200px rounded'
          style={{ backgroundColor: '#E2E5EA' }}
        >
          <FormControl variant='outlined' fullWidth>
            <Select
              labelId='demo-simple-select-outlined-label'
              id='demo-simple-select-outlined'
              value={isLoadingCurriculum ? '' : currentLA?._id || ''}
              onChange={onChange}
              size='small'
              disabled={isLoadingCurriculum}
              displayEmpty
              sx={{
                '& .MuiSelect-select': {
                  paddingTop: '4px',
                  paddingBottom: '4px',
                  backgroundColor: '#fff',
                  borderRadius: '4px',
                  border: '1px solid #fff'
                }
              }}
            >
              {isLoadingCurriculum ? (
                <MenuItem value='' disabled>
                  <Typography variant='body2' color='textSecondary'>
                    Loading...
                  </Typography>
                </MenuItem>
              ) : (
                Object.keys(groupedOptions).map((group) => [
                  Object.keys(groupedOptions).length === 1 ? null : (
                    <ListSubheader key={group}>{group}</ListSubheader>
                  ),
                  groupedOptions[group].map((op, i) => (
                    <MenuItem
                      key={`${op._id}-${i}`}
                      value={op._id}
                      disabled={op.disabled}
                      className={op.className ?? ''}
                    >
                      {op.name}
                    </MenuItem>
                  ))
                ])
              )}
            </Select>
          </FormControl>
        </div>
      </div>
      <div className='px-4 pt-2 pb-4'>
        {/* MF-529 — minmax(0, 1fr): columns shrink instead of overflowing on narrow screens */}
        <div className='grid gap-4 mb-4' style={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
          <InfoCard
            title='Skills Assessed'
            icon={faClipboardCheck}
            value={assessedCount?.length || 0}
            bgColor='white'
            isLoading={isLoadingDashboard || isLoadingCurriculum}
            onClick={() =>
              setModal({
                show: true,
                type: 'skills Assessed',
                data: assessedCount
              })
            }
          />
          <InfoCard
            title='Growing Skills'
            icon={faSparkles}
            value={growingCount?.length || 0}
            bgColor='white'
            isLoading={isLoadingDashboard || isLoadingCurriculum}
            onClick={() =>
              setModal({
                show: true,
                type: 'growing Skills',
                data: growingCount
              })
            }
          />
          <InfoCard
            title='Self Checks'
            icon={faChartLine}
            value={selfCheckCount?.length || 0}
            bgColor='white'
            isLoading={isLoadingDashboard || isLoadingCurriculum}
            onClick={() =>
              setModal({
                show: true,
                type: 'self Checks',
                data: selfCheckCount
              })
            }
          />
        </div>

        <div className='grid gap-4'>
          <YourGrowthJourney
            isLoadingDashboard={isLoadingDashboard}
            isLoadingCurriculum={isLoadingCurriculum}
            data={data?.yourGrowthJourney || []}
          />
          <SkillsSnapshot
            isLoadingDashboard={isLoadingDashboard}
            isLoadingCurriculum={isLoadingCurriculum}
            data={data}
          />
        </div>
      </div>
      {modal.show && (
        <DialogLcs
          show={modal.show}
          type={modal.type}
          onClose={() => setModal({ show: false, type: null, data: null })}
          data={modal.data}
        />
      )}
    </Box>
  )
}

export default LearningAreaOverview
